import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { UploadDocs } from './components/UploadDocs';
export function AppRouter() {
  return <BrowserRouter data-id="element-14">
      <Routes data-id="element-15">
        <Route path="/" element={<App data-id="element-17" />} data-id="element-16" />
        <Route path="/upload-docs" element={<UploadDocs data-id="element-19" />} data-id="element-18" />
      </Routes>
    </BrowserRouter>;
}